'use client';

import { atom } from 'jotai';

export const openLeasinglLeadModalAtom = atom(false);
